import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalExpiration extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.state = {
			show: false,
			reasons:[],
			reason_key:"",
			item:{},
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(item){
		console.log(item)
		console.log("ruta",Config.default.apiGateway.URL+'lookups?type=reason_to_send_units_expired_petition&option=actives&order=true');
		fetch(Config.default.apiGateway.URL+'lookups?type=reason_to_send_units_expired_petition&option=actives&order=true',{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({reasons:response, show:true, item: item});
			}
				
		});
		//this.setState({show:true});
	}

	handleClose(){
		this.setState({show:false, reasons:[],reason_key:"",item:{}});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	handleSubmit(e){
		e.preventDefault();
		
		if(this.state.reason_key !== ""){
			var obj = {
				reason:this.state.reason_key,
				petition_id:this.state.item.petition_id,
				units:[]
			}

			this.state.item.items.map((u)=>{
				obj.units.push(u.unit_id);
			});
			fetch(Config.default.apiGateway.URL+'traceabilities/send_unit_expired_petition',{
				method: 'post',
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					
					this.props.saving(this.state.item);
					this.handleClose();
				}
					
			});
		}else{
			swal('Error', 'Debe seleccionar un motivo', 'error');
		}
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
				<Modal.Header>
					<Modal.Title>Motivo de envio</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12">
							<div className="col-xs-12">
								<span>La petición ha expirado, seleccione un motivo de envio de unidades</span>
							</div>
							<div className="col-xs-12 col-sm-6">
								<select className="form-control" name="reason_key" id="reason_key"
									value={this.state.reason_key} onChange={this.handleChange}>
									<option value="">Seleccione...</option>
									{this.state.reasons.map((r, i)=>(
										<option key={i} value={r.key}>{r.name}</option>
									))}
								</select>
							</div>
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer>
					<FlatButton primary={true} label={t('content.generics.buttons.save')} 
						onClick={this.handleSubmit} /> 
					<FlatButton primary={true} label={t('content.generics.buttons.close')} 
						onClick={this.handleClose} /> 
				</Modal.Footer>
			</Modal>
		)
	}
}

export default translate('translations')(ModalExpiration)